// src/components/SidebarMenu/SidebarMenuItem.js
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const SidebarMenuItem = React.memo(function SidebarMenuItem({
    item,
    warehouseId,
    isCollapsed,
    badge,
}) {
    const { t } = useTranslation()
    const location = useLocation()

    const resolvedHref = item.href.replace(':warehouse_id', warehouseId)
    const isActive = location.pathname === resolvedHref ||
        location.pathname.startsWith(resolvedHref + '/')

    const Icon = item.icon
    const label = t(`navegation_routes.${item.name.toLowerCase()}`)

    if (isCollapsed) {
        return (
            <Link
                to={resolvedHref}
                title={label}
                aria-label={label}
                className={`relative flex items-center justify-center w-10 h-10 rounded-md mx-auto
                    ${isActive ? 'bg-gray-100' : 'hover:bg-gray-100'}`}
            >
                <Icon className="w-5 h-5" style={{ color: '#DCA118' }} />
                {badge && (
                    <span className="absolute -top-1 -right-1">{badge}</span>
                )}
            </Link>
        )
    }

    return (
        <Link
            to={resolvedHref}
            className={`flex items-center gap-2.5 px-3 py-2 rounded-md text-sm
                ${isActive
                    ? 'bg-gray-100 font-semibold text-gray-900'
                    : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                }`}
        >
            <Icon className="w-5 h-5 flex-shrink-0" style={{ color: '#DCA118' }} />
            <span className="truncate">{label}</span>
            {badge && <span className="ml-auto">{badge}</span>}
        </Link>
    )
})

export default SidebarMenuItem
